import { render } from "./profileModalComponent.vue?vue&type=template&id=bf6f1cfa&scoped=true"
import script from "./profileModalComponent.vue?vue&type=script&lang=js"
export * from "./profileModalComponent.vue?vue&type=script&lang=js"

import "./profileModalComponent.vue?vue&type=style&index=0&id=bf6f1cfa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6f1cfa"]])

export default __exports__